import { render, staticRenderFns } from "./TrademarkTransactionReport.vue?vue&type=template&id=31a49f35&"
import script from "./TrademarkTransactionReport.vue?vue&type=script&lang=js&"
export * from "./TrademarkTransactionReport.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkTransactionReport.vue?vue&type=style&index=0&id=31a49f35&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports